import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=e8be500a&scoped=true"
import script from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FontSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FontSelector.vue?vue&type=style&index=0&id=e8be500a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8be500a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8be500a')) {
      api.createRecord('e8be500a', component.options)
    } else {
      api.reload('e8be500a', component.options)
    }
    module.hot.accept("./FontSelector.vue?vue&type=template&id=e8be500a&scoped=true", function () {
      api.rerender('e8be500a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/fontSelector/FontSelector.vue"
export default component.exports